import React, { useState, useEffect } from 'react';
import "../CSS/RevenueCycle.css";
import revenueCycleHero from "../Images/solutions/Revenue Cycle Optimization/solution-revenue-cycle-optimization.png";
import revenueCycleHeroMob from "../Images/Mobile Images/solutions/Revenue Cycle Optimization/solution-revenue-cycle-optimization-image-mobile.png";
import revenueCycleDividerImg from "../Images/solutions/Revenue Cycle Optimization/revenue-cycle-optimization-divider-image.png";
import revenueCycleDividerImgMob from "../Images/Mobile Images/solutions/Revenue Cycle Optimization/revenue-cycle-optimization-divider-image-mobile.png";
import revenueCycleUpperDividerImgMob from "../Images/Mobile Images/solutions/Revenue Cycle Optimization/revenue-cycle-optimization-upper-divider-image-mobile.png";
import peopleIcon from "../Images/services/people-icon.svg";
import processIcon from "../Images/services/process-icon.svg";
import resultsIcon from "../Images/services/results-icon.svg";
import { useNavigate } from 'react-router-dom';
import { Paper } from '@mui/material';

type ChecklistItem = {
  title: string;
  desc: string | string[];
};



const checklistContent = [
  {
    title: 'Medical Records Management',
    desc: 'Simplify your medical record operations with our expert assistance. We cover everything from data intake and quick retrieval to systematic sorting and consistent tagging, making your records easier to manage.'
  },
  {
    title: 'Home Health Care',
    desc: 'Optimizing your workflow, we focus on providing and enhancing processes for intake services, OASIS management, coding, patient education, and scheduling.'
  },
  {
    title: 'Full-Service Coding Services',
    desc: 'We offer comprehensive medical coding and documentation services, including Risk Adjustment & HCC, Outpatient, Inpatient, and Home Health Coding, alongside CDI & Provider Education and Intake & Patient Registration.'
  },
  {
    title: 'Telehealth & Remote Patient Monitoring',
    desc: 'We ensure the delivery of quality care through a comprehensive approach, combining telehealth, remote patient monitoring, case management support, and care coordination.'
  },
  {
    title: 'UM, Pre Auth, Pre-Service & Post-Service Verifications',
    desc: 'We provide efficient UM Clinical Reviews through our highly skilled, experienced Registered Nurses, who expertly handle pre- and post-service checks across various medical specializations.'
  },
  {
    title: 'Charge Capture',
    desc: 'Our process ensures documentation and accurate capture of appropriate charges related to procedures, streamlining your billing and compliance.'
  },
  {
    title: 'Denial Management',
    desc: 'Highly-skilled and experienced registered nurses are at the forefront of our operations, expertly resolving denials across critical areas like State Authorization, Coding, and Medical Necessity.'
  },
];

const REVENUE_STATS_LABELS = [
  { desktop: <>Accuracy Score Verified<br />by 3rd Party Audits</>, mobile: 'Accuracy Score Verified by 3rd Party Audits' },
  { desktop: <>Credentialed Coders &<br />RCM Practitioners</>, mobile: 'Credentialed Coders & RCM Practitioners' },
  { desktop: <>RCM Tasks Completed<br />Annually</>, mobile: 'RCM Tasks Completed Annually' },
  { desktop: <>Years of Management in<br />CDI/ Coding Education</>, mobile: 'Years of Management in CDI/ Coding Education' },
];

const RevenueCycle: React.FC = () => {
  const [selectedIdx, setSelectedIdx] = useState(0);
  const [isMobileStats, setIsMobileStats] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 1100px)');
    const handle = () => setIsMobileStats(mq.matches);
    handle();
    mq.addEventListener('change', handle);
    return () => mq.removeEventListener('change', handle);
  }, []);

  return (
    <div>
      <div className="revenue-cycle-hero">
        <div className="revenue-cycle-hero-img" style={{ '--hero-bg': `url(${revenueCycleHero})`, '--hero-bg-mob': `url(${revenueCycleHeroMob})`, backgroundImage: `url(${revenueCycleHero})` } as React.CSSProperties}>
          <div className="revenue-cycle-hero-content">
            <div className="revenue-cycle-hero-subtitle">Revenue Cycle Optimization</div>
            <div className="revenue-cycle-hero-title">Unlock Full Reimbursement<br />Potential with Precision</div>
            <div className="revenue-cycle-hero-desc">
              Leverage expert coders dedicated to improving revenue integrity and claim accuracy.
            </div>
          </div>
        </div>
      </div>
      <div className="scalable-solution-intro">
        <h2 className="scalable-solution-title">Scalable, Quality-Driven Solutions for Your RCM and Coding Teams</h2>
        <div className="scalable-solution-desc">Discover our comprehensive services tailored to meet your specific operational needs.</div>
        <button onClick={() => navigate('/contact-us#contact-us-top')} className="scalable-solution-contact-btn">Contact Us</button>
      </div>
      <div className="scalable_solutions_checklist">
        <div className="scalable_solutions_checklist_left">
          {checklistContent.map((item, idx) => (
            <button
              key={item.title}
              className={`ssc-btn${selectedIdx === idx ? ' active' : ''}`}
              onClick={() => setSelectedIdx(idx)}
              type="button"
            >
              <span className={`ssc-btn-num${selectedIdx === idx ? ' active' : ''}`}>
                {selectedIdx === idx ? (
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <circle cx="16" cy="16" r="16" fill="#21747a"/>
                    <text x="16" y="22" textAnchor="middle" fontSize="18" fontWeight="700" fill="#fff">{idx + 1}</text>
                  </svg>
                ) : (
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <circle cx="16" cy="16" r="16" fill="#e6f2f3"/>
                    <text x="16" y="22" textAnchor="middle" fontSize="18" fontWeight="700" fill="#21747a">{idx + 1}</text>
                  </svg>
                )}
              </span>
              <span className="ssc-btn-label">{item.title}</span>
            </button>
          ))}
        </div>
        <div className="scalable_solutions_checklist_right"
          onTouchStart={(e) => {
            const touchDown = e.touches[0].clientX;
            e.currentTarget.setAttribute('data-touch-start', touchDown.toString());
          }}
          onTouchMove={(e) => {
            const touchDown = e.currentTarget.getAttribute('data-touch-start');
            if (!touchDown) return;
            const currentTouch = e.touches[0].clientX;
            const diff = Number(touchDown) - currentTouch;
            if (diff > 5) {
              // Swipe Left -> Next
              setSelectedIdx((prev) => (prev + 1) % checklistContent.length);
              e.currentTarget.removeAttribute('data-touch-start');
            } else if (diff < -5) {
              // Swipe Right -> Prev
              setSelectedIdx((prev) => (prev - 1 + checklistContent.length) % checklistContent.length);
              e.currentTarget.removeAttribute('data-touch-start');
            }
          }}
        >
          <div
            className="mobile-nav-arrow mobile-nav-prev"
            onClick={() => setSelectedIdx((prev) => (prev - 1 + checklistContent.length) % checklistContent.length)}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
          </div>

          <div className="ssc-right-content-wrapper">
            <h3 className="ssc-title">{checklistContent[selectedIdx].title}</h3>
            <div className="ssc-desc">{checklistContent[selectedIdx].desc}</div>
          </div>

          <div
            className="mobile-nav-arrow mobile-nav-next"
            onClick={() => setSelectedIdx((prev) => (prev + 1) % checklistContent.length)}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </div>
        </div>
      </div>
      <div className="revenue-statistics">
        <div className="revenue-statistics-heading">
          Quality Isn't Just a Metric—It's a Mission. <b>Medwell360 Delivers Nothing Less.</b>
        </div>
        <div className="revenue-statistics-row">
          <div className="revenue-statistics-item">
            <div className="revenue-statistics-value">95%</div>
            <div className="revenue-statistics-label">{isMobileStats ? REVENUE_STATS_LABELS[0].mobile : REVENUE_STATS_LABELS[0].desktop}</div>
          </div>
          <div className="revenue-statistics-item">
            <div className="revenue-statistics-value">300+</div>
            <div className="revenue-statistics-label">{isMobileStats ? REVENUE_STATS_LABELS[1].mobile : REVENUE_STATS_LABELS[1].desktop}</div>
          </div>
          <div className="revenue-statistics-item">
            <div className="revenue-statistics-value">5M+</div>
            <div className="revenue-statistics-label">{isMobileStats ? REVENUE_STATS_LABELS[2].mobile : REVENUE_STATS_LABELS[2].desktop}</div>
          </div>
          <div className="revenue-statistics-item">
            <div className="revenue-statistics-value">15+</div>
            <div className="revenue-statistics-label">{isMobileStats ? REVENUE_STATS_LABELS[3].mobile : REVENUE_STATS_LABELS[3].desktop}</div>
          </div>
        </div>
      </div>
      {/* AI Services for RCM Table Section */}
      <div className="ai-service-table">
        <div className="ai-service-table-header">
          <h2 className="ai-service-table-title">AI Services for RCM</h2>
          <div className="ai-service-table-subtitle">
            Advanced Applications Across the Revenue Cycle
          </div>
        </div>
        <table className="ai-service-table-container">
          <thead>
            <tr>
              <th className="ai-service-table-header-cell">Traditional Process</th>
              <th className="ai-service-table-header-cell">AI Enhancement</th>
              <th className="ai-service-table-header-cell">Outcomes</th>
            </tr>
          </thead>
          <tbody>
            {[{
              traditional: 'Pre-visit & Patient Access',
              ai: 'AI agents automate eligibility checks and flag mismatches before scheduling',
              outcome: (<><span>20-40% reduced claim denials</span><br /><span className="ai-service-table-outcome-secondary">• Faster registration process</span></>),
            }, {
              traditional: 'Medical Coding & Documentation',
              ai: 'NLP extracts terms from notes and suggests codes with continuous learning',
              outcome: (<><span>30% increase in coder productivity</span><br /><span className="ai-service-table-outcome-secondary">• Reduced under/over-coding risks</span></>),
            }, {
              traditional: 'Claims Management',
              ai: 'Agentic bots automate claim creation, scrubbing, and EDI submission',
              outcome: (<><span>95% clean claim rate</span><br /><span className="ai-service-table-outcome-secondary">• Reduced administrative workload</span></>),
            }, {
              traditional: 'Denial Management',
              ai: 'AI triages denials by category and auto generates appeal letters',
              outcome: (<><span>50-70% reduction in denial rates</span><br /><span className="ai-service-table-outcome-secondary">• Continuous process optimization</span></>),
            }, {
              traditional: 'Patient Billing & Collections',
              ai: 'AI tailors bills based on payment behavior; virtual agents handle inquiries',
              outcome: (<><span>15-25% increased patient collections</span><br /><span className="ai-service-table-outcome-secondary">• Improved satisfaction and transparency</span></>),
            }, {
              traditional: 'Analytics & Forecasting',
              ai: 'AI dashboards with predictive analytics for cash flow forecasting',
              outcome: (<><span>Better financial planning</span><br /><span className="ai-service-table-outcome-secondary">• Faster issue detection</span></>),
            }].map((row, idx) => (
              <tr key={row.traditional}>
                <td colSpan={3} className="ai-service-table-row-cell">
                  <div className="ai-service-table-row">
                    <div className="ai-service-table-col ai-service-table-col-traditional">{row.traditional}</div>
                    <div className="ai-service-table-col ai-service-table-col-ai">{row.ai}</div>
                    <div className="ai-service-table-col ai-service-table-col-outcome">{row.outcome}</div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Key AI Technologies Section */}
      <div className="key-ai-tech">
        <div className="key-ai-tech-title">
          Key AI Technologies powering RCM
        </div>
        <div className="key-ai-tech-container">
          {/* RPA */}
          <div className="key-ai-tech-card">
            <img src={require('../Images/solutions/Revenue Cycle Optimization/Icons/rpa-icon.svg').default} alt="RPA Icon" className="key-ai-tech-icon" />
            <div className="key-ai-tech-card-title">RPA</div>
            <div className="key-ai-tech-card-desc">Automates repititive tasks across<br />workflows</div>
          </div>
          {/* NLP */}
          <div className="key-ai-tech-card">
            <img src={require('../Images/solutions/Revenue Cycle Optimization/Icons/nlp-icon.svg').default} alt="NLP Icon" className="key-ai-tech-icon" />
            <div className="key-ai-tech-card-title">NLP</div>
            <div className="key-ai-tech-card-desc">Extracts meaning from clinical<br />documentation</div>
          </div>
          {/* Machine Learning */}
          <div className="key-ai-tech-card">
            <img src={require('../Images/solutions/Revenue Cycle Optimization/Icons/machine-learning-icon.svg').default} alt="Machine Learning Icon" className="key-ai-tech-icon" />
            <div className="key-ai-tech-card-title">Machine Learning</div>
            <div className="key-ai-tech-card-desc">Predicts denials and optimizes<br />collections</div>
          </div>
          {/* Conversational AI */}
          <div className="key-ai-tech-card">
            <img src={require('../Images/solutions/Revenue Cycle Optimization/Icons/conversational-ai-icon.svg').default} alt="Conversational AI Icon" className="key-ai-tech-icon" />
            <div className="key-ai-tech-card-title">Conversational AI</div>
            <div className="key-ai-tech-card-desc">Patient engagement and billing<br />support</div>
          </div>
        </div>
      </div>
      {/* Zemantics AI Facts Section */}
      <div className="zemantics-ai-facts">
        <div className="zemantics-ai-facts-left">
          <div className="zemantics-ai-facts-title">AI Benefits for RCM</div>
          <div className="zemantics-ai-facts-subtitle">Transforming Healthcare Financial Operations</div>
          <button className="zemantics-ai-facts-contact-btn" onClick={() => navigate('/contact-us#contact-us-top')}>Contact Us</button>
        </div>
        <div className="zemantics-ai-facts-right">
          <div className="zemantics-ai-facts-cards">
            <div className="zemantics-ai-facts-card">
              <div className="zemantics-ai-facts-card-title">End-to-End Automation</div>
              <div className="zemantics-ai-facts-card-desc">AI automates entire workflows from patient scheduling to payment posting, reducing manual effort and labor costs.<br /><br />Staff Productivity Increase</div>
              <div className="zemantics-ai-facts-card-stat">35-45%</div>
            </div>
            <div className="zemantics-ai-facts-card">
              <div className="zemantics-ai-facts-card-title">Error Reduction</div>
              <div className="zemantics-ai-facts-card-desc">AI enhances claim accuracy, minimizes denials, and ensures regulatory compliance across all processes.<br /><br />Claim Denial Reduction</div>
              <div className="zemantics-ai-facts-card-stat">50-70%</div>
            </div>
            <div className="zemantics-ai-facts-card">
              <div className="zemantics-ai-facts-card-title">Time Efficiency</div>
              <div className="zemantics-ai-facts-card-desc">AI significantly reduces days in A/R, accelerates reimbursement cycles, and improves overall cash flow.<br /><br />Reduction in Days in A/R</div>
              <div className="zemantics-ai-facts-card-stat">25-30%</div>
            </div>
            <div className="zemantics-ai-facts-card">
              <div className="zemantics-ai-facts-card-title">Enhanced Patient Experience</div>
              <div className="zemantics-ai-facts-card-desc">AI enables 24/7 support for billing questions, personalized payment plans, and transparent financial counseling.<br /><br />Patient Collection Improvement</div>
              <div className="zemantics-ai-facts-card-stat">15-25%</div>
            </div>
          </div>
        </div>
      </div>
      {/* AI Trends Statistics Section */}
      <div className="ai-trends-statistics">
        <div className="ai-trends-statistics-title">AI Trends for RCM</div>
        <div className="ai-trends-statistics-row">
          <div className="ai-trends-statistics-item">
            <div className="ai-trends-statistics-value">46%</div>
            <div className="ai-trends-statistics-desc">of hospitals and health systems have<br />implemented AI in their RCM operations</div>
          </div>
          <div className="ai-trends-statistics-item">
            <div className="ai-trends-statistics-value">92%</div>
            <div className="ai-trends-statistics-desc">of RCM leaders prioritize investing in AI and<br />advanced automation for 2025</div>
          </div>
          <div className="ai-trends-statistics-item">
            <div className="ai-trends-statistics-value">68%</div>
            <div className="ai-trends-statistics-desc">of RCM executives report improved net<br />collections with AI-powered solutions</div>
          </div>
        </div>
      </div>
      {/* Overall Revenue Impact Section */}
      <div className="overall-revenue-impact">
        <div className="overall-revenue-impact-title">Overall Revenue Impact</div>
        <div className="overall-revenue-impact-row">
          <div className="overall-revenue-impact-card">
            <div className="overall-revenue-impact-value">5 - 15%</div>
            <div className="overall-revenue-impact-desc">Average net Collection Increase</div>
          </div>
          <div className="overall-revenue-impact-card">
            <div className="overall-revenue-impact-value">6 - 12 months</div>
            <div className="overall-revenue-impact-desc">Average Time-to-Implementation ROI</div>
          </div>
        </div>
      </div>
      {/* AI Image Divider Section */}
      <div className="ai-image-divider">
        <picture>
          <source media="(max-width: 1100px)" srcSet={revenueCycleUpperDividerImgMob} />
          <img
            src={require('../Images/solutions/Revenue Cycle Optimization/revenue-cycle-optimization-upper-divider-image.png')}
            alt="Revenue Cycle Optimization Divider"
            className="ai-image-divider-img"
          />
        </picture>
      </div>
      {/* Key Success Factors Section */}
      <div className="key-success-factors">
        <div className="key-success-factors-title">Key Success Factors</div>
        <div className="key-success-factors-row">
          <div className="key-success-factors-item">
            <img src={require('../Images/green-tick-icon.svg').default} alt="Checkmark" className="key-success-factors-icon" />
            <span>Focus on end-to-end process integration</span>
          </div>
          <div className="key-success-factors-item">
            <img src={require('../Images/green-tick-icon.svg').default} alt="Checkmark" className="key-success-factors-icon" />
            <span>Human-in-the-loop model for complex decisions</span>
          </div>
          <div className="key-success-factors-item">
            <img src={require('../Images/green-tick-icon.svg').default} alt="Checkmark" className="key-success-factors-icon" />
            <span>Ongoing staff training and change management</span>
          </div>
        </div>
      </div>
      <div className="revenue-healthcare-challenges">
        <div className="revenue-healthcare-challenges-heading">
          Understand Today's Healthcare Challenges
        </div>
        <div className="revenue-healthcare-challenges-cards">
          <div className="revenue-healthcare-challenge-card">
            <div className="revenue-healthcare-challenge-title">Coder Shortages Undermine Accuracy and Revenue</div>
            <div className="revenue-healthcare-challenge-desc">A limited supply of skilled coders often results in inconsistent quality—making it harder to optimize reimbursement and maintain compliance.</div>
          </div>
          <div className="revenue-healthcare-challenge-card">
            <div className="revenue-healthcare-challenge-title">Rising Operational Costs</div>
            <div className="revenue-healthcare-challenge-desc">Volatile patient volumes and labor market constraints are putting increased financial strain on healthcare organizations.</div>
          </div>
          <div className="revenue-healthcare-challenge-card">
            <div className="revenue-healthcare-challenge-title">Delayed and Lost Revenue</div>
            <div className="revenue-healthcare-challenge-desc">Late, inaccurate, or denied claims contribute to revenue leakage and cash flow disruption—limiting the financial agility of your practice.</div>
          </div>
        </div>
      </div>
      <div className="revenue-image">
        <picture>
          <source media="(max-width: 1100px)" srcSet={revenueCycleDividerImgMob} />
          <img
            src={revenueCycleDividerImg}
            alt="Revenue Cycle Optimization Divider"
            className="revenue-image-img"
          />
        </picture>
      </div>
      <div className="revenue-hq-clinical-outcomes left-align">
        <div className="revenue-hq-clinical-outcomes-heading">
          Partner with Us to Deliver Scalable, High-Quality Clinical Outcomes
        </div>
        <div className="revenue-hq-clinical-outcomes-cards">
          <div className="revenue-hq-clinical-outcomes-card">
            <div className="revenue-hq-clinical-outcomes-icon" aria-label="People">
              <img src={peopleIcon} alt="People Icon" style={{ width: '48px', height: '48px' }} />
            </div>
            <div className="revenue-hq-clinical-outcomes-title">People</div>
            <ul className="revenue-hq-clinical-outcomes-list">
              <li>100% of our coders are <b>certified by AHIMA or AAPC</b></li>
              <li>Our <b>coding educators average 10+ years of professional experience</b></li>
              <li>Our <b>coding certification program</b> has maintained a <b>&gt;95% pass rate over the last 5 years</b></li>
              <li>Certified coders from our internal pipeline achieve <b>&gt;90% retention</b>, well above industry benchmarks</li>
            </ul>
          </div>
          <div className="revenue-hq-clinical-outcomes-card">
            <div className="revenue-hq-clinical-outcomes-icon" aria-label="Process">
              <img src={processIcon} alt="Process Icon" style={{ width: '48px', height: '48px' }} />
            </div>
            <div className="revenue-hq-clinical-outcomes-title">Process</div>
            <ul className="revenue-hq-clinical-outcomes-list">
              <li>We <b>recruit and onboard top-tier talent</b> through a rigorous selection process</li>
              <li>Our <b>comprehensive training and quality assurance platform</b> ensures readiness and accuracy</li>
              <li><b>Transparent reporting and performance metrics</b> keep stakeholders informed</li>
              <li><b>Six Sigma methodologies</b> drive continuous improvement and operational efficiency</li>
              <li>We offer the <b>ability to implement concurrent coding</b> for faster claim cycles</li>
            </ul>
          </div>
          <div className="revenue-hq-clinical-outcomes-card">
            <div className="revenue-hq-clinical-outcomes-icon" aria-label="Results">
              <img src={resultsIcon} alt="Results Icon" style={{ width: '48px', height: '48px' }} />
            </div>
            <div className="revenue-hq-clinical-outcomes-title">Results</div>
            <ul className="revenue-hq-clinical-outcomes-list">
              <li>Achieve <b>45–60% cost savings</b> through optimized delivery models</li>
              <li>Improve cash flow with consistent turnaround time compliance and reduced DNFB (Discharged Not Final Billed)</li>
              <li>Boost reimbursement through higher coding accuracy and quality</li>
              <li>Eliminate the staffing burden of recruitment, training, and workforce management</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RevenueCycle; 